import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment'
import SelectForm from './../components/Complements/SelectForm';
import Title from './../components/Complements/Title';
import DateFnsUtils from '@date-io/date-fns';
import "moment/locale/es";
import esLocale from "date-fns/locale/es";
import { connect } from 'react-redux';
import { getCredits } from "./../actions/credits";

import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from '@material-ui/pickers';
import { Grid, CircularProgress, Icon, Fab } from '@material-ui/core';
// import MaterialTable from 'material-table';

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import './../components/Codes/style/tableresponsive.css';
import Pagination from '@material-ui/lab/Pagination';
import Alert from '@material-ui/lab/Alert';
import Dashboard from '../components/Menu/Dashboard';
import { history } from '../helpers/history';
import { isEmpty } from '../functions/arrays';
// import ReactExport from "react-export-excel";
import Button from '@material-ui/core/Button';
import { consolidateCreditReport } from '../functions/credits-report';

// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const CreditsContainer = props => {
    const { classes, getCredits, secuencial} = props
    const [ creditspaginate, setCreditsPaginate ] = useState([])
    const [ credits, setCredits ] = useState([])
    const [ page, setPage ] = useState(1)
    const [ count, setCount ] = useState(1)
    // const [ secuencialAccount, setSecuencialAccount ] = useState(secuencial)
    const [ loading, setLoading ] = useState(false)
    const [ dateStart, setDateStart ] = useState(new Date(moment().startOf('month')))
    const [ dateEnd, setDateEnd ] = useState(new Date(moment().endOf('month')))
    const [ dateValue, setDateValue ] = useState(JSON.stringify({month: moment().month(), year: moment().year()}))
    const mount = () => {
        const unmount = () => {
            try {
                moment.locale('es-es')
                if (isEmpty(credits)) {
                    handleGetCredits()
                } else if (credits.infoPayment) {
                    if (credits.infoPayment.length > 0 ) {
                        handleGetCredits()
                    }
                }
            } catch (error) {
                //console.log(error)
            }
            
        }
        return unmount()
    }
    useEffect(mount, [secuencial])
    // functions
    const handleGetCredits = () => {
        getCredits({SecuencialPrestamo: parseInt(secuencial), SecuencialEmpresa: 1}).then( res => {
            //console.log(res)
            setLoading(false)
            // setCredits(res.payload.data.PagosPrestamo)
            
            // setSecuencialAccount(match.params.id)
            // let InitialDate = (dateStart.getFullYear()) + "-" + (dateStart.getMonth() +1) + "-" + dateStart.getDate()
            filterCreditsByDate(dateStart, moment(dateEnd).format('YYYY-MM-DD'))
            // getDataViewTableCredits(res.payload.data.PagosPrestamo)
        }).catch( error => {
            //console.log('no se a podido encontrar codes', error)
        })
    }
    const dateAfter = (str1, str2) =>
    {
        return new Date(str1) >= new Date(str2);
    }
    const dateBefore = (str1, str2) =>
    {
        return new Date(str1) <= new Date(str2);
    }
    const filterCreditsByDate = (dateStart,  dateEnd) => {
        try {
            const dataResult = props.credits.tablePayment.PagosPrestamo.filter((credit) => {
                
                let dateFormat = moment(credit.FechaVencimiento, ['YYYY/MM/DD', 'DD/MM/YYYY']).format('YYYY-MM-DD hh:mm:ss')
                return dateAfter(dateFormat, dateStart) && dateBefore(dateFormat, dateEnd)
            })
            //console.log(dataResult)
            getDataViewTableCredits(dataResult)
            setCredits(dataResult)
        } catch (error) {
            // console.log('error filterCreditsByDate ', error)
        }
    }
    const getDataViewTableCredits = (credits) => {
        let dataCreditsPaginate = [];
        let count = parseInt((credits.length / 5).toString());
        let residuo = credits.length % 5;

        if(residuo > 0){
            count++;
        }

        if(credits.length > 0){
            dataCreditsPaginate = credits.slice(0, 5);
        }
        setCreditsPaginate(dataCreditsPaginate)
        setCount(count)
        setPage(1)
    }
    const handleDateStart = (date) => {
        setDateStart(date)
    }
    const handleDateEnd = (date) => {
        setDateEnd(date)
    }
    const handleSubmit = (val) => {
    }
    const onChangePaginationCredits = (e, page) => {
        let init = (page - 1) * 5;
        let end = page * 5;
        let dataCreditsPaginate = [];
        dataCreditsPaginate = credits.slice(init, end)
        setCreditsPaginate(dataCreditsPaginate)
        setPage(page)
    }

    //render
    const renderTableMovements = () => {
        if (loading) {
            return <CircularProgress />
        } else {
            if (creditspaginate.length > 0) {
                return  <div className = { "container" }>
                        <Grid item xs={12} md={12} lg = {12}>
                            {/* <ExcelFile element={<Button size = { "large"} variant="contained" >Exportar a Excel</Button>} filename = {"Movimientos de Creditos"}>
                                <ExcelSheet data={credits} name="Movimientos">
                                    <ExcelColumn label="Fecha de pago" value={(col) => moment(col.FechaDePago).format("YYYY-MM-DD")}/>
                                    <ExcelColumn label="Fecha de vencimiento" value={(col) => moment(col.FechaVencimiento).format("YYYY-MM-DD")}/>
                                    <ExcelColumn label="# Cuota" value="NumeroCuota"/>
                                    <ExcelColumn label="Capital" value="Capital"/>
                                    <ExcelColumn label="Interes" value="Interes"/>
                                    <ExcelColumn label="Comisión" value="Comision"/>
                                    <ExcelColumn label="Seguro Desgravamen" value="SeguroDesgravamen"/>
                                    <ExcelColumn label="Total Cuota" value="TotalCuota"/>
                                    <ExcelColumn label="Saldo capital" value="SaldoCapital"/>
                                    <ExcelColumn label="Tasa" value="Tasa"/>
                                    <ExcelColumn label="Estado" value="Estado"/>
                                </ExcelSheet>
                                
                            </ExcelFile> */}
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={ async() => await consolidateCreditReport(credits) } >
                                    Exportar a Excel
                            </Button>
                        </Grid>
                        <br />
                        <br />
                        <Grid item xs={12} md={12} lg = {12}>
                            <Table className = {"table"}>
                                <Thead>
                                    <Tr>
                                        <Th>Fecha de pago</Th>
                                        <Th>Fecha de vencimiento</Th>
                                        <Th># Cuota</Th>
                                        <Th>Capital</Th>
                                        <Th>Interés</Th>
                                        <Th>Comisión</Th>
                                        <Th>Seguro Desgravamen</Th>
                                        <Th>Total Cuota</Th>
                                        <Th>Saldo capital</Th>
                                        <Th>Tasa</Th>
                                        <Th>Estado</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    { 
                                        creditspaginate.map(row => (
                                            <Tr key={row.Documento}>
                                                <Td>{ moment(row.FechaDePago).format("YYYY-MM-DD")}</Td>
                                                <Td>{ moment(row.FechaVencimiento).format("YYYY-MM-DD")}</Td>
                                                <Td>{row.NumeroCuota}</Td>
                                                <Td>{row.Capital}</Td>
                                                <Td>{row.Interes}</Td>
                                                <Td>{row.Comision}</Td>
                                                <Td>{row.SeguroDesgravamen}</Td>
                                                <Td>$ {row.TotalCuota}</Td>
                                                <Td>$ {row.SaldoCapital}</Td>
                                                <Td>{row.Tasa}</Td>
                                                <Td>{row.Estado}</Td>
                                            </Tr>
                                        ))
                                    }
                                </Tbody>
                            </Table>
                        </Grid>
                            <Pagination 
                                count = { count } 
                                color = "primary" 
                                page = { page }
                                onChange = { onChangePaginationCredits }
                            />
                        </div>
            } else {
                return <Alert severity="info">No se han encontrado movimientos en el mes seleccionado.</Alert>
            }
        }
    }
    const handleSelectCredits = (val) => {
        try {
            setDateValue(val)
            setLoading(true)
            setCredits(props.credits.tablePayment.PagosPrestamo)
            if (val === 'Todos los movimientos') {
                setLoading(false)
                setCredits(props.credits.tablePayment.PagosPrestamo)
                getDataViewTableCredits(props.credits.tablePayment.PagosPrestamo);
            } else {
                let obj = JSON.parse(val)
                let selectMonth = new Date(obj.year, obj.month, 1)
                setDateStart(moment(selectMonth).startOf('month'))
                setDateEnd(moment(selectMonth).endOf('month'))
                if (props.credits.tablePayment.PagosPrestamo.length > 0) {
                    let dateStart = moment(selectMonth).startOf('month').format('YYYY-MM-DD')
                    let dateEnd = moment(selectMonth).endOf('month').format('YYYY-MM-DD')
                    filterCreditsByDate(dateStart, dateEnd)
                    setDateValue(val)
                    setLoading(false)
                } else {
                    // setCredits([])
                    getDataViewTableCredits([])
                    setLoading(false)
                }
            }
        } catch (error) {
            //console.log(error)
        }
    }
    const handleFindRange = () => {
        try {
            if (credits.length > 0) {
                filterCreditsByDate(dateStart, dateEnd)
            } else {
                handleGetCredits()
            }
        } catch (error) {
            //console.log(error)
        }
    }
    const renderBody = () => {
        return  <div>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={8} lg = {8} sm = {12}>
                            <Title>Detalle de Créditos </Title>
                        </Grid>
                        <Grid item xs={12} md={4} lg = {4} sm = {12}>
                        </Grid>
                    </Grid>
                    <SelectForm
                        name = { 'Periodo' }
                        label = { 'Seleccione periodo '}
                        // data = { [{ id: '1', name: 'data'}] }
                        classes = { classes }
                        dateValue = { dateValue }
                        onSelected = { (val) => handleSelectCredits(val)}
                        onSubmit={ handleSubmit }
                    ></SelectForm>
                    <br></br>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Grid container justify="center" spacing={3}  alignItems="flex-end">
                                <Grid item md={4} sm={12} xs={12}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                        <KeyboardDatePicker
                                            autoOk
                                            variant="inline"
                                            format="dd/MM/yyyy"
                                            margin="normal"
                                            id="date-start"
                                            label="Fecha de inicio"
                                            value={dateStart}
                                            onChange={handleDateStart}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item md={4} sm={12} xs={12}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                        <KeyboardDatePicker
                                            autoOk
                                            variant="inline"
                                            format="dd/MM/yyyy"
                                            margin="normal"
                                            id="date-end"
                                            label="Fecha de fin"
                                            value={dateEnd}
                                            onChange={handleDateEnd}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item md={2} sm={6} xs={6}>
                                    <Fab color="primary" style= {{ backgroundColor:'#00a0af'}} aria-label="add" onClick = { handleFindRange } >
                                        <Icon>search</Icon>
                                    </Fab>
                                </Grid>
                                <Grid item md={2} sm={6} xs={6}>
                                    <Fab color="primary" aria-label="add" onClick = { () => history.push('/')} >
                                        <Icon>close</Icon>
                                    </Fab>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <br/> <br/>
                    <Grid container justify="center" spacing={3}  alignItems="center">
                        {
                            renderTableMovements()
                        }
                    </Grid>
                </div>
    }
    return (
        <div>
            <Dashboard
                title= "Dashboard"
                body = { renderBody() }
                multiple = { false }
            />
        </div>
    );
};

CreditsContainer.propTypes = {
    secuencial: PropTypes.string.isRequired,
};

export default connect(null , { getCredits })(CreditsContainer);